<template>
  <v-dialog
    ref="dialog"
    v-model="modalContact"
    width="320px"
  >
    <v-form v-model="valid" style="background-color: white;">
      <v-text-field
        v-model="contactName"
        :label="$t('Formulary.Contact Name')"
        append-icon="mdi-account"
        style="margin-left: 20px; margin-right: 20px; width: 280px;"
        :rules="rules.name"
      />

      <v-text-field
        v-model="contactNIF"
        :label="$t('Formulary.Contact NIF/CIF')"
        append-icon="mdi-passport"
        style="margin-left: 20px; margin-right: 20px; width: 280px"
        :rules="rules.cif"
      />

      <v-text-field
        v-model="contactEmail"
        :label="$t('Formulary.Contact Email')"
        append-icon="mdi-email"
        style="margin-left: 20px; margin-right: 20px; width: 280px"
        :rules="rules.email"
      />

      <v-text-field
        v-model="contactPhone"
        :label="$t('Formulary.Contact phone')"
        append-icon="mdi-phone"
        style="margin-left: 20px; margin-right: 20px; width: 280px"
        :rules="rules.phone"
      />
      <v-btn :disabled="!valid" style="margin-left: 90px" text color="primary" @click="addContact">
        {{ $t('Formulary.AddContact') }}
      </v-btn>
    </v-form>
  </v-dialog>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";

export default {
    name: "AddClient",
    data () {
        return {
            modalContact: false,
            contactName: "",
            contactNIF: "",
            contactEmail: "",
            contactPhone: "",
            rules: {
                name: [v => !!v || this.$t('A name is required'), ],
                value: [v => !!v || this.$t('The value field is required'), ],
                number: [v => !!v || this.$t('The phone field is required'), ],
                phone: [ v => /^(\+?[\d ]{9,}|)$/.test(v) || this.$t('The phone must be valid') ],
                email: [ v => (/.+@.+\..+/.test(v) || v === "") || this.$t('The mail must be valid.') ],
                cif: [
                    v => !!v || this.$t('A cif is required'),
                    //v => /^[a-zA-Z0-9]{1}[0-9]{7}[a-zA-Z0-9]{1}$/.test(v) || v === '' || this.$t('The CIF must be valid (Example formats: A12345678, 12345678B, C1234567D)'),
                    v => v.toUpperCase() !== this.$user.cif.toUpperCase() || this.$t('Error.The CIF must be different than yours.')
                ],
            },
            valid: true
        };
    },
    methods: {
        openModal () {
            this.modalContact = true;
        },
        closeModal () {
            this.modalContact = false;
        },
        addContact () {
            console.log("patata")
            const contact = {
                cif: this.contactNIF,
                name: this.contactName,
                email: this.contactEmail,
                phone: this.contactPhone
            };
            ApiRepository.addContact(this.$user.cif, contact).then((res) => {
                this.closeModal();
                this.contactName = "";
                this.contactNIF = "";
                this.contactEmail = "";
                this.contactPhone = "";
                this.$root.$emit('show-snackbar', {message: this.$t('Contact added successfully!'), color: "success"});
                this.$emit('added', {contactId: res.data.contact._id, contact: res.data.contact});
            }).catch((e) => {
                this.$root.$emit('show-snackbar', {message: e, color: "error"});
            });
        },
    }
};
</script>

<style scoped>

</style>
